// Copyright (c) 2016 Deere & Company

import {translate} from '../../shared/services/translation-service';

export const formatClaimNumber = claimNumber => claimNumber.replace(/^0+/, '');

export const formatClaimNumberTitle = claimNumber => `${translate('CLAIM')} ${formatClaimNumber(claimNumber)}`;



// WEBPACK FOOTER //
// ./src/shared/services/format-claim-number.js